var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"role":"main"}},[_c('meta-title',{attrs:{"title":_vm.metaTitle}}),_c('section',{staticClass:"section section-default section-text"},[_c('div',{staticClass:"container m-container-only-s"},[_c('LegalPolicy')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }